export default {
  "terms-and-conditions-link": "_terms-and-conditions-link_fk04q"
};